module.exports = __webpack_public_path__ + "static/img/logo2.19c67ba3.png";